// extracted by mini-css-extract-plugin
export default {"background":"BackgroundImage_background__SW+xq"};